module.exports = __webpack_public_path__ + "img/fountain-garden.7943ec36.webp";